// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_6a21cc', '__Roboto_Fallback_6a21cc'","fontStyle":"normal"},"className":"__className_6a21cc","variable":"__variable_6a21cc"};